<ng-container
  adobeAnalytics
  [srcUrl]="analyticsUrl"
  [adobeDataLayer]="adobeDataLayer"
>
</ng-container>
<div
  class="axis-wrapper"
  axis-accessibility
>
  @if (!router.url.match("/thank-you|/home|/invalid|/maintenance")) {
    <app-navbar></app-navbar>
  }
  <main
    class="axis-main-container"
    [class._layout-column]="router.url.match('/home')"
    id="content"
    role="main"
  >
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
  <axis-scroll2tb></axis-scroll2tb>
</div>

<axis-alert
  class="kind-{{ notificationType === 'error' ? 'danger' : notificationType }}"
  [dismissible]="true"
  [autoClose]="alertAutoClose"
  [datafadeout]="alertFadeOut"
  [timeOut]="alertTimeOut"
  type="notification"
  #alertComponent
>
  <axis-notification>
    @if (notificationTitle) {
      <div
        class="axis-alert-title"
        [innerHTML]="notificationTitle"
      ></div>
    }
    <div
      [innerHTML]="notificationMessage"
      notification
    ></div>
  </axis-notification>
</axis-alert>
